<template>
	<div style="height: 100%;display: flex;flex-direction: column;">
		<div class="position-relative w-50">
			<input type="text" v-model="searchKeyword" class="structure-search mb-3" placeholder="جستجو" />
			<i v-if="searchKeyword" @click="searchKeyword = ''" class="fas fa-times empty-entity-search"></i>
		</div>
		<div class="entity-container">
			<div v-for="(entity, index) in filteredEntitiesStructure" :key="index" :title="entity.entityTitle" :class="[
				'entity',
				{
					selected: selectedEntity && entity.entityType == selectedEntity.entityType,
				},
			]" @click="selectedEntity = entity">
				{{ entity.entityTitle }}
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import _ from 'lodash'

	export default {
		name: 'EntitySelector',
		emits: ['update:modelValue'],
		props: {
			modelValue: {
				type: Object,
			},
		},
		data() {
			return {
				selectedEntity: null,
				searchKeyword: ''
			}
		},
		watch: {
			selectedEntity: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.selectedEntity)
				},
			},
			modelValue: {
				deep: true,
				handler(val) {
					this.selectedEntity = this.entitiesStructure.find(x => x.entityType == val?.entityType)
				},
			},
		},
		computed: {
			...mapGetters({ entitiesStructure: 'queryDesigner/entitiesStructure' }),
			filteredEntitiesStructure() {
				let items = _.cloneDeep(this.entitiesStructure)
				if (this.searchKeyword && this.searchKeyword !== '') {
					items = items.filter(
						(x) => x.entityTitle.indexOf(this.searchKeyword) > -1
					)
				}
				return items
			}
		},
	}
</script>

<style scoped></style>